import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { GBSCError } from "@/models/GBSCError";

import {
  IMemeberList,
  IMemberListDetail,
} from "@/models/ApiRequestResponse/patient";

import { getMemberListApi } from "@/utils/apis/patient/profile";

export const fetchPatientMembers = createAsyncThunk<IMemeberList | GBSCError>(
  "patient/fetchPatientMember",
  async () => {
    const response = await getMemberListApi();
    return response;
  }
);

const fetchPatientMembersSlice = createSlice({
  name: "fetchPatientMember",
  initialState: {
    list: [] as IMemberListDetail[],
    isMemberModalOpenClose: false as boolean,
    isLoading: true as boolean,
  },
  reducers: {
    setMemberModalOpenClose: (state) => {
      state.isMemberModalOpenClose = !state.isMemberModalOpenClose;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPatientMembers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPatientMembers.fulfilled, (state, action) => {
        state.isLoading = false;
        if ("result" in action.payload) {
          state.list = action.payload.result;
        }
      })
      .addCase(fetchPatientMembers.rejected, (state) => {
        state.isLoading = false;
      });
  },
});
export const { setMemberModalOpenClose } = fetchPatientMembersSlice.actions;
export default fetchPatientMembersSlice.reducer;
